<div class="close-modal">
  <button [mat-dialog-close]="true" class="close-button hand-cursor">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav mode="side" opened>
    <mat-nav-list>
      <mat-list-item *ngFor="let tab of availableTabs"
                     [activated]="selectedTab == tab.value"
                     (click)="selectedTab = tab.value">
        {{ tab.name }}
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-container [ngSwitch]="selectedTab">
      <app-policy-overview
        *ngSwitchCase="Tabs.PolicyOverview"
        (policyIdValue)="onSetPolicyId($event)"
        (policyNumber)="onSetPolicyNumber($event)"
        (policyholderGroupIdValue)="onSetPolicyholderGroupId($event)"></app-policy-overview>
      <app-member-overview *ngSwitchCase="Tabs.MemberOverview"></app-member-overview>
      <app-document-overview *ngSwitchCase="Tabs.Documents"></app-document-overview>
      <ng-container *ngSwitchCase="Tabs.VivaScoreOverview">
        <ng-container *ngIf="isAllowHealthCloudScore else restrictTpl1">
          <app-vivascore-profile-overview
            *ngIf="canView() else certainRolesToAccessToViewData"></app-vivascore-profile-overview>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="Tabs.HomeAffairsPersonProfile">
        <ng-container *ngIf="isAllowedGovernmentData else restrictTpl2">
          <app-home-affairs-person-profile
            *ngIf="canView() else certainRolesToAccessToViewData"></app-home-affairs-person-profile>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="Tabs.Cases">
        <app-cases-overview *ngIf="canView() else certainRolesToAccessToViewData"></app-cases-overview>
      </ng-container>
      <ng-container *ngSwitchCase="Tabs.Transactions">
        <app-transaction-overview *ngIf="canView() else certainRolesToAccessToViewData"
                                  [policyNumber]="policyNumber"></app-transaction-overview>
      </ng-container>
      <ng-container *ngSwitchCase="Tabs.Contributions">
        <member-contributions-overview *ngIf="canView() else certainRolesToAccessToViewData"
                                       [policyNumber]="policyNumber"></member-contributions-overview>
      </ng-container>
      <ng-container *ngSwitchCase="Tabs.Utilisation">
        <app-utilisations-overview *ngIf="canView() else certainRolesToAccessToViewData" [policyId]="policyID"
                                   [policyNumber]="policyNumber"></app-utilisations-overview>
      </ng-container>
      <ng-container *ngSwitchCase="Tabs.Payments">
        <app-payment-overview *ngIf="canView() else certainRolesToAccessToViewData"></app-payment-overview>
      </ng-container>
      <app-sms-overview *ngSwitchCase="Tabs.SMS"></app-sms-overview>
      <app-email-overview *ngSwitchCase="Tabs.Email"></app-email-overview>
    </ng-container>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Empty Placeholder Section-->
<ng-template #certainRolesToAccessToViewData>
  <div class="center">
    <label class="mat-primary-color">Only Team Leaders and Managers can view data for staff policies</label>
  </div>
</ng-template>


<ng-template #restrictToSeeDetails let-heading>
  <app-dialog-heading [heading]="heading"></app-dialog-heading>
  <div class="center">
    <label class="mat-primary-color">{{ DisplayStrings.cannotView }}</label>
  </div>
</ng-template>

<ng-template #restrictTpl1>
  <ng-container *ngTemplateOutlet="restrictToSeeDetails;
      context: {$implicit: 'VivaScore Profile'}">
  </ng-container>
</ng-template>

<ng-template #restrictTpl2>
  <ng-container *ngTemplateOutlet="restrictToSeeDetails;
      context: {$implicit: 'Department of Home Affairs Person Profile'}">
  </ng-container>
</ng-template>